"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _construct = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _classCallCheck = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chainLinkAsync = exports.chainAsync = exports.chainLink = exports.chain = void 0;

var _deepCopy = _interopRequireDefault(require("../../util/deepCopy"));

var _logger = _interopRequireDefault(require("../../logger"));

var _register = require("./register");

var _type = require("./type");

var _data = require("./data");

var _graph = require("./graph");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function prepareParseGraph(graph) {
  return graph.reduce(function (array, next) {
    var last = array[array.length - 1];

    if (last && last.type === next.type) {
      last.count = last.count + 1 || 2;
    } else {
      array.push(next);
    }

    return array;
  }, []).map(function (element) {
    return (element.count > 1 ? element.count + 'x ' : '') + element.type;
  }).join(' -> ');
}

var ChainParser = /*#__PURE__*/function () {
  function ChainParser(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ChainParser);

    this.options = Object.assign({
      generateGraph: true,
      forceType: (0, _type.type)(input),
      maxChainLength: 10,
      strict: true,
      target: '@csl/list+object'
    }, options);
    this.type = this.options.forceType;
    this.data = typeof input === 'object' ? (0, _deepCopy["default"])(input) : input;
    this.graph = [{
      type: this.type,
      data: input
    }];
    this.iteration = 0;
  }

  _createClass(ChainParser, [{
    key: "iterate",
    value: function iterate() {
      if (this.iteration !== 0) {
        var typeInfo = (0, _register.get)(this.type);

        if (typeInfo && typeInfo.outputs) {
          this.type = typeInfo.outputs;
        } else {
          this.type = (0, _type.type)(this.data);
        }

        this.graph.push({
          type: this.type
        });
      }

      if (this.error || this.type === this.options.target) {
        return false;
      } else if (this.iteration >= this.options.maxChainLength) {
        this.error = new RangeError("Max. number of parsing iterations reached (".concat(prepareParseGraph(this.graph), ")"));
        return false;
      } else {
        this.iteration++;
        return true;
      }
    }
  }, {
    key: "end",
    value: function end() {
      var _this = this;

      if (this.error) {
        _logger["default"].error('[core]', this.error.message);

        if (this.options.strict !== false) {
          throw this.error;
        } else {
          return [];
        }
      } else if (this.options.target === '@csl/list+object') {
        return this.data.map(this.options.generateGraph ? function (entry) {
          return (0, _graph.applyGraph)(entry, _this.graph);
        } : _graph.removeGraph);
      } else {
        return this.data;
      }
    }
  }]);

  return ChainParser;
}();

var chain = function chain() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var chain = _construct(ChainParser, args);

  while (chain.iterate()) {
    try {
      chain.data = (0, _data.data)(chain.data, chain.type);
    } catch (e) {
      chain.error = e;
    }
  }

  return chain.end();
};

exports.chain = chain;

var chainLink = function chainLink(input) {
  var type = (0, _type.type)(input);
  var output = type.match(/array|object/) ? (0, _deepCopy["default"])(input) : input;
  return (0, _data.data)(output, type);
};

exports.chainLink = chainLink;

var chainAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len2,
        args,
        _key2,
        chain,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = _args[_key2];
            }

            chain = _construct(ChainParser, args);

          case 2:
            if (!chain.iterate()) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return (0, _data.dataAsync)(chain.data, chain.type)["catch"](function (e) {
              chain.error = e;
            });

          case 5:
            chain.data = _context.sent;
            _context.next = 2;
            break;

          case 8:
            return _context.abrupt("return", chain.end());

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function chainAsync() {
    return _ref.apply(this, arguments);
  };
}();

exports.chainAsync = chainAsync;

var chainLinkAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
    var type, output;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            type = (0, _type.type)(input);
            output = type.match(/array|object/) ? (0, _deepCopy["default"])(input) : input;
            return _context2.abrupt("return", (0, _data.dataAsync)(output, type));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function chainLinkAsync(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.chainLinkAsync = chainLinkAsync;